module.exports = __webpack_public_path__ + "img/pr-12.79b5aa58.png";